import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { publicSiteIdentity } from "./lib/bookingHost";
import "./manifest-tokens.css";

document.title = `${publicSiteIdentity().brand} · Buchung`;

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found.");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
